/* istanbul ignore file */
import axios from 'axios';
import {isEmpty} from 'lodash';

const getHeaders = () => {
  return {
    'Content-Type': 'application/json',
    ...(!isEmpty(localStorage.getItem('token')) && {
      'access-token': localStorage.getItem('token'),    
    }),
  };
};

export default axios.create({
  baseURL: process.env.REACT_APP_ENABLE_MOCKS === 'true' ? 'http://' + window.location.host : process.env.REACT_APP_SERVER_URL_FOR_CDL, //YOUR_API_URL HERE
  headers: getHeaders(),
});
